import { render, staticRenderFns } from "./base-column-id-small.vue?vue&type=template&id=6449d0f7&scoped=true&"
import script from "./base-column-id-small.vue?vue&type=script&lang=js&"
export * from "./base-column-id-small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449d0f7",
  null
  
)

export default component.exports